import { HttpInterceptorFn } from '@angular/common/http';
import { effect, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { from, switchMap, take } from 'rxjs';
import { FirebaseAuthService } from '../services/firebase-auth.service';


export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
   const fbAuth = inject(FirebaseAuthService);
 // const cookieService = inject(CookieService);

   if (req.headers.has('Authorization')) {
    return next(req);
  }

 /* other way to exclude token in request */
 
  // const excludedEndpoints = ['/auth/register', '/auth/verify-otp'];

  // if (excludedEndpoints.some(url => req.url.includes(url))) {
  //   return next(req); // Skip token for these APIs
  // } 

// Fetch token asynchronously and clone request
  return from(fbAuth.getFreshToken()).pipe(
    switchMap(token => {
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          }
        });
      }
      return next(req);
    })
  );


  // return fbAuth.currentToken$.pipe(
  //   take(1),
  //   switchMap(token => {
  //     if (token) {
  //       console.log('Interceptor adding token:', token);
  //       req = req.clone({
  //         setHeaders: { Authorization: `Bearer ${token}` }
  //       });
  //     }
  //     return next(req);
  //   })
  // );
  // Try cookie first, fallback to sessionStorage
  //const token =  auth.getValidToken();
//     fbAuth.currentToken$.subscribe(token =>  {
//     if (token) {
//       console.log('Token interceptor - token:', token);
//          req = req.clone({
//       setHeaders: {
//         Authorization: `Bearer ${token}`,
//       }
//     });
//     //  this.router.navigate([ROUTES.GUEST.HOME]);
//     } else {
//       console.log('Token interceptor ..User is logged out or token expired');
//     }
//   });
//  return next(req);
};
